import { useTable } from './useTable';
export function useIsGroup(id) {
  var table = useTable();
  var columnManager = table.getColumnManager();
  var column = columnManager.getColumn(id);

  if (column == null) {
    throw new Error('invalid column key = ' + id);
  }

  return column.isGroup();
}